import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';

/**
 * Generated class for the EditweaponsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editweapons',
  templateUrl: 'editweapons.html',
})
export class EditweaponsPage {

  we: any

  Title = ''
  _name = ''
  _brand = ''
  _code = ''
  _model = ''
  _caliber = ''
  _serialnumber = ''

  loadingData: boolean = false
  drivers = []
  driversleft = []

  allDrivers = []
  selectedArray: any = [];
  myToast: any




  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController) {
    this.we = navParams.get('we')
    if (this.we.id == -1) {
      this.Title = this.dic.l["addweapon"]
      this.getAllDriversforInsert()

    } else {
      this._name = this.we.name
      this._brand = this.we.brand
      this._code = this.we.code
      this._model = this.we.model
      this._caliber = this.we.caliber
      this._serialnumber = this.we.serialnum
      this.Title = this.dic.l["editweapon"] + ' ' + this._name
      this.getDrivers()
      this.getDriversLeft()
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditweaponsPage');

  }

  getDrivers() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/weapondriver', { weaponid: this.gn.crypt(this.we.id) }, function (_data) {
      // console.log(_data, 'daj da vidam data')
      _that.drivers = _data
      _that.loadingData = false
    })
  }

  getDriversLeft() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/weapondriverLeft', { weaponid: this.gn.crypt(this.we.id), cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.driversleft = _data
      _that.loadingData = false
    })
  }

  addWeaponDriver() {
    var _that = this
    if (this.driversleft.length == 0) {
      let alert = this.alertCtrl.create({
        title: this.dic.l["addweapondriver"],
        subTitle: this.dic.l['alldriverschoosen'],
        buttons: [this.dic.l["ok"]]
      });
      alert.present();
    }
    else {
      let alert = this.alertCtrl.create();
      alert.setTitle(this.dic.l["addweapondriver"]);

      var ch = false
      alert.addInput({
        type: 'checkbox',
        label: this.dic.l["All"],
        value: '0',
        checked: ch,
        handler: (data) => {
          if (data.value + '' == '0') {
            if (this.driversleft.length > 0) {
              for (let i = 1; i < alert['instance']['d']['inputs'].length; i++) {
                alert['instance']['d']['inputs'][i]['checked'] = alert['instance']['d']['inputs'][0]['checked']
              }
            }
          }
        }
      })

      for (var i = 0; i < this.driversleft.length; i++) {
        var ch = false
        for (var j = 0; j < this.drivers.length; j++) {
          if (this.drivers[j].id == this.driversleft[i].id) {
            ch = true
            break
          }
        }
        alert.addInput({
          type: 'checkbox',
          label: this.driversleft[i].fullname,
          value: this.driversleft[i].id,
          checked: ch
        });
      }
      alert.addButton(this.dic.l["cancel"]);
      alert.addButton({
        text: this.dic.l["ok"],

        handler: data => {
          _that.gn.loadWaiting();
          for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < _that.driversleft.length; j++) {
              if (_that.driversleft[j].id == data[i]) {
                _that.drivers.push(_that.driversleft[j])
              }
            }
            _that.gn._Post('/api/gn/insertdriverwaepon',
              {
                weaponid: _that.gn.crypt(_that.we.id),
                driver: _that.gn.crypt(data[i])
              }, function (_data) {
                _that.driversleft = []
                _that.getDriversLeft();
                if (i == data.length - 1) {
                  _that.gn.loaderWaiting.dismiss();
                }
              })
          }
        }
      });
      alert.present();
    }
  }

  deleteWeaponDriver(id: number, name: string, idx: number) {
    var _that = this;
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["deleteweaponDriver"],
      subTitle: _that.dic.l["areyouwantodelDriver"] + ' ' + name,
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            this.gn._Post('/api/gn/delWeaponDriver', { driver: this.gn.crypt(id) }, function (_data) {
              _that.drivers.splice(idx, 1);
              _that.driversleft = [];
              _that.getDriversLeft();
              _that.gn.loaderWaiting.dismiss();
            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }


  addWeapon() {
    if (this.myToast != null) {
      return
    }

    if (this._name + '' == "") {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addname"], buttons: [this.dic.l['ok']] });
      alert.present();
      return

    }
    if (this._brand + '' == "") {
      const alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addbrand"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }
    if (this._code + '' == "") {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addcode"], buttons: [this.dic.l['ok']] });
      alert.present();
      return

    }
    if (this._model + '' == "") {
      const alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addmodel"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }
    if (this._caliber + '' == "") {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addcaliber"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (this._serialnumber + '' == "") {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addserialnumber"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }


    var _dat = {
      name: this.gn.crypt(this._name),
      brand: this.gn.crypt(this._brand),
      code: this.gn.crypt(this._code),
      model: this.gn.crypt(this._model),
      caliber: this.gn.crypt(this._caliber),
      serialnum: this.gn.crypt(this._serialnumber),
      clientid: this.gn.crypt(this.gn.user.ClientId),
      drivers: this.gn.crypt(this.selectedArray),
    }

    var _that = this
    _that.gn.loadWaiting();
    this.gn._Post('/api/gn/addWeapon', _dat, function (_data) {
      _that.gn.loaderWaiting.dismiss();
      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _cb()
      }
      var _msg = _that.dic.l["succaddweapon"]
      let toast = _that.toastCtrl.create({
        message: _msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })
  }

  editWeapon() {

    if (this.myToast != null) {
      return
    }

    if (this._name + '' == "") {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addname"], buttons: [this.dic.l['ok']] });
      alert.present();
      return

    }
    if (this._brand + '' == "") {
      const alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addbrand"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }
    if (this._code + '' == "") {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addcode"], buttons: [this.dic.l['ok']] });
      alert.present();
      return

    }
    if (this._model + '' == "") {
      const alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addmodel"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }
    if (this._caliber + '' == "") {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addcaliber"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (this._serialnumber + '' == "") {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addserialnumber"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }



    var _dat = {
      id: this.gn.crypt(this.we.id),
      name: this.gn.crypt(this._name),
      brand: this.gn.crypt(this._brand),
      code: this.gn.crypt(this._code),
      model: this.gn.crypt(this._model),
      caliber: this.gn.crypt(this._caliber),
      serialnum: this.gn.crypt(this._serialnumber),
    }
    var _that = this
    _that.gn.loadWaiting();
    this.gn._Post('/api/gn/editWeapon', _dat, function (_data) {
      _that.gn.loaderWaiting.dismiss();
      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _cb()
      }
      var _msg = _that.dic.l["succeditweapon"]
      let toast = _that.toastCtrl.create({
        message: _msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })
  }


  getAllDriversforInsert() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getalldrivers', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.allDrivers = _data
      _that.loadingData = false
    })
  }


  checkAll() {
    for (let i = 0; i <= this.allDrivers.length; i++) {
      this.allDrivers[i].checked == true;
    }
  }

  selectMember(data) {
    if (data.checked == true) {
      this.selectedArray.push(data.id);
    }
    else {
      for (let i = 0; i < this.selectedArray.length; i++) {
        if (this.selectedArray[i] == data.id) {
          this.selectedArray.splice(i, 1);
        }
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/settings/weapons/editweapons.ts